import { api } from '../api/client';

/**
 * Fetch a member's submitted requirement file and hand it to the browser.
 *
 * Submissions used to be plain links into the public /uploads mount, which made
 * the URL itself the only credential. They are now behind an authenticated
 * route, so the bytes have to come through the API client (bearer token) and be
 * handed over as an object URL.
 */
export const downloadRequirementFile = async (
  memberId: string,
  requirementId: string,
  isUserView = false,
): Promise<void> => {
  const res = await api.uploads.downloadSubmission(memberId, requirementId, isUserView);

  const disposition = String(res.headers?.['content-disposition'] ?? '');
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match?.[1] ?? 'submission';

  const blob = new Blob([res.data as BlobPart]);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
